export default {
  loading: false,
  activeStep: 0,
  order: {},
  volumeOrItem: '',
  orderForm: {
    order_number: '',
    created: new Date().toISOString(),
    quote_id: null,
    scheduled: false,
    shipment_order_type: 'RETURN',
    shipment_order_sub_type: 'PICKUP',
    delivery_method_id: null,
    delivery_method_external_id: null,
    sales_channel: '',
    estimated_delivery_date: new Date(),
    invoice_total_value: 0.0,
    provider_shipping_costs: 0.0,
    first_name: '',
    last_name: '',
    email: '',
    federal_tax_payer_id: '',
    phone: '',
    cellphone: '',
    shipping_address: '',
    shipping_number: '',
    shipping_additional: '',
    shipping_reference: '',
    shipping_quarter: '',
    shipping_city: '',
    shipping_zip_code: '',
    shipping_state: '',
    shipping_state_code: '',
    shipping_country: '',
    delivery_information: {
      address: {},
    },
    shipment_order_volume_array: [],
    seller: {},
  },
  quoteInfo: {
    logistic_provider: {
      delivery_methods: [],
    },
  },
  sellers: [],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-reverse/features/create-reverse/store/states.js